/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Webhook = {
    id?: string;
    hook_type?: Webhook.hook_type;
    url?: string;
    ad_account_id?: string;
    pixel_id?: string;
    custom_conversions?: boolean;
};
export namespace Webhook {
    export enum hook_type {
        WBH = 'wbh',
        FBC = 'fbc',
        GAC = 'gac'
    }
}

